var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerfectPr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 885 325",
    style: {
      enableBackground: "new 0 0 885 325"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#04994A;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#5D5B5D;}\n\t.st2{fill:#04994A;}\n\t.st3{fill:#5D5B5D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LINES_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.7,203.7l-65.5-85.3L83.7,34H67.6L1,118.3l65.5,85.3H83.7z M52.5,119.3H36.4l64.4,84.3L35.3,289h17.2 l65.5-85.3L52.5,119.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "89.6,122 74,122 133.4,206 73,289 88.6,289 149,205  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Perfect_PR"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.9,238.9V289h-16.1V161h40.8c11.9,0,21.2,3.6,28,10.7c6.8,7.1,10.2,16.6,10.2,28.4 c0,12.3-3.2,21.8-9.7,28.4c-6.5,6.7-15.6,10.1-27.4,10.3H190.9z M190.9,225.1h24.7c7.1,0,12.6-2.1,16.4-6.4 c3.8-4.3,5.7-10.4,5.7-18.4c0-7.7-2-13.9-5.9-18.5c-3.9-4.6-9.3-7-16.2-7h-24.8V225.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.8,290.8c-11.8,0-20.9-3.5-27.2-10.6c-6.3-7.1-9.6-17.4-9.7-31.1v-11.5c0-14.2,3.1-25.3,9.3-33.4 c6.2-8.1,14.8-12.1,25.9-12.1c11.1,0,19.5,3.5,25,10.6c5.5,7.1,8.3,18.1,8.4,33.1v10.2h-53.1v2.2c0,10.2,1.9,17.6,5.8,22.2 c3.8,4.6,9.4,6.9,16.6,6.9c4.6,0,8.6-0.9,12.1-2.6c3.5-1.7,6.8-4.5,9.8-8.2l8.1,9.8C325.9,286,315.6,290.8,301.8,290.8z  M300.1,205.5c-6.4,0-11.2,2.2-14.3,6.6c-3.1,4.4-4.9,11.3-5.3,20.6h37.4v-2.1c-0.4-9-2-15.5-4.9-19.3 C310.2,207.4,305.9,205.5,300.1,205.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M387.9,208.5c-2.2-0.4-4.5-0.6-7-0.6c-8,0-13.5,4.4-16.7,13.1v68h-15.6v-95.1h15.1l0.3,9.7 c4.2-7.6,10-11.4,17.7-11.4c2.5,0,4.5,0.4,6.2,1.2L387.9,208.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M408.2,289v-82.5h-12.4v-12.6h12.4v-11c0.2-9.7,2.6-17.2,7.3-22.6c4.7-5.4,11.4-8.1,20-8.1 c3.1,0,6.2,0.5,9.4,1.5l-0.8,13.1c-2.2-0.5-4.6-0.8-7.1-0.8c-8.8,0-13.3,6.3-13.3,19v9H440v12.6h-16.3V289H408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M486.8,290.8c-11.8,0-20.9-3.5-27.2-10.6c-6.3-7.1-9.6-17.4-9.7-31.1v-11.5c0-14.2,3.1-25.3,9.3-33.4 c6.2-8.1,14.8-12.1,25.9-12.1c11.1,0,19.5,3.5,25,10.6c5.5,7.1,8.3,18.1,8.4,33.1v10.2h-53.1v2.2c0,10.2,1.9,17.6,5.8,22.2 c3.8,4.6,9.4,6.9,16.6,6.9c4.6,0,8.6-0.9,12.1-2.6c3.5-1.7,6.8-4.5,9.8-8.2l8.1,9.8C510.9,286,500.6,290.8,486.8,290.8z  M485,205.5c-6.4,0-11.2,2.2-14.3,6.6c-3.1,4.4-4.9,11.3-5.3,20.6h37.4v-2.1c-0.4-9-2-15.5-4.9-19.3 C495.1,207.4,490.8,205.5,485,205.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M566.7,277.5c5.2,0,9.3-1.6,12.4-4.8c3.1-3.2,4.8-7.7,5.1-13.7h14.7c-0.4,9.1-3.6,16.7-9.7,22.7 c-6.1,6-13.6,9-22.5,9c-11.8,0-20.8-3.7-26.9-11.1c-6.2-7.4-9.3-18.4-9.3-33.1v-10.5c0-14.4,3.1-25.3,9.2-32.7 s15.1-11.2,26.9-11.2c9.7,0,17.4,3.1,23.2,9.2s8.7,14.6,9.1,25.2h-14.7c-0.4-7-2-12.3-5.1-15.8c-3-3.5-7.2-5.3-12.5-5.3 c-6.9,0-12,2.3-15.4,6.8c-3.3,4.5-5.1,12-5.2,22.4v12.1c0,11.2,1.7,19.1,5,23.7C554.3,275.2,559.5,277.5,566.7,277.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M633.7,170.9v23H648v12.6h-14.3v59c0,3.8,0.6,6.6,1.8,8.5s3.3,2.9,6.3,2.9c2,0,4.1-0.4,6.2-1.1L648,289 c-3.5,1.2-7.1,1.7-10.8,1.7c-6.2,0-10.8-2.2-14.1-6.6c-3.2-4.4-4.8-10.6-4.8-18.6v-59.1h-14.5v-12.6h14.5v-23H633.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M719.2,238.9V289h-16.1V161h40.8c11.9,0,21.2,3.6,28,10.7c6.8,7.1,10.2,16.6,10.2,28.4 c0,12.3-3.2,21.8-9.7,28.4c-6.5,6.7-15.6,10.1-27.4,10.3H719.2z M719.2,225.1h24.7c7.1,0,12.6-2.1,16.4-6.4 c3.8-4.3,5.7-10.4,5.7-18.4c0-7.7-2-13.9-5.9-18.5c-3.9-4.6-9.3-7-16.2-7h-24.8V225.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M838.1,237.2h-22.5V289h-16.2V161h35.9c12.5,0,22,3.3,28.5,9.8c6.4,6.5,9.7,16.1,9.7,28.7 c0,7.9-1.7,14.8-5.2,20.7c-3.5,5.9-8.4,10.3-14.8,13.3l24.8,54.4v1.1h-17.3L838.1,237.2z M815.6,223.4h19.5 c6.7,0,12.1-2.2,16.1-6.5c4-4.3,6-10.2,6-17.4c0-16.4-7.4-24.7-22.3-24.7h-19.3V223.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AGENCY_OF_PUBLIC_COMMUNICATIONS_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M190.3,80.6h-7l-1.4,5.2h-5.5l8-25.6h4.7l8.1,25.6h-5.5L190.3,80.6z M184.3,76.3h4.8l-2.4-9.1L184.3,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M220.2,83c-1,1.1-2.2,1.9-3.7,2.4c-1.4,0.5-3,0.8-4.8,0.8c-2.9,0-5.2-0.9-6.9-2.7c-1.6-1.8-2.5-4.5-2.5-8 v-4.6c0-3.5,0.8-6.2,2.3-8.1c1.5-1.9,3.8-2.9,6.7-2.9c2.8,0,4.9,0.7,6.3,2.1c1.4,1.4,2.2,3.5,2.5,6.5h-5c-0.1-1.6-0.5-2.7-1-3.3 c-0.5-0.6-1.4-0.9-2.5-0.9c-1.4,0-2.4,0.5-3,1.5s-1,2.6-1,4.9v4.6c0,2.3,0.3,4,1,5.1c0.7,1.1,1.8,1.6,3.4,1.6 c1,0,1.8-0.2,2.5-0.6L215,81v-4.7h-3.6v-3.9h8.8V83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.7,74.8h-8.1v6.8h9.5v4.3h-14.7V60.3h14.7v4.3h-9.5v6h8.1V74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M266.6,85.9h-5.2l-7.6-16.8v16.8h-5.2V60.3h5.2l7.6,16.8V60.3h5.2V85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M291.7,77.4c-0.1,2.9-0.9,5.1-2.5,6.6s-3.6,2.3-6.4,2.3c-2.9,0-5.1-1-6.7-2.9s-2.3-4.6-2.3-8.1v-4.3 c0-3.5,0.8-6.2,2.4-8.1s3.8-2.9,6.6-2.9c2.8,0,4.9,0.8,6.4,2.3s2.3,3.8,2.5,6.7h-5.2c0-1.8-0.3-3-0.8-3.7s-1.4-1-2.8-1 c-1.4,0-2.4,0.5-2.9,1.5s-0.9,2.6-0.9,4.8v4.8c0,2.5,0.3,4.3,0.9,5.2s1.5,1.4,2.9,1.4c1.4,0,2.3-0.3,2.8-1s0.8-1.9,0.9-3.6H291.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.2,71.8l3.8-11.5h5.6l-6.9,16.3v9.3h-5.2v-9.3l-6.9-16.3h5.6L306.2,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M351.5,75.4c0,3.4-0.8,6.1-2.4,8c-1.6,1.9-3.9,2.8-6.8,2.8c-2.9,0-5.1-0.9-6.8-2.8c-1.6-1.9-2.5-4.5-2.5-7.9 v-4.4c0-3.5,0.8-6.3,2.4-8.2c1.6-2,3.9-3,6.8-3c2.8,0,5.1,1,6.7,2.9c1.6,1.9,2.5,4.7,2.5,8.2V75.4z M346.3,71.1 c0-2.3-0.3-4-1-5.2c-0.7-1.1-1.7-1.7-3.1-1.7c-1.4,0-2.4,0.5-3,1.6c-0.7,1.1-1,2.7-1,4.9v4.6c0,2.2,0.3,3.9,1,4.9 s1.7,1.6,3.1,1.6c1.3,0,2.3-0.5,3-1.6c0.7-1,1-2.6,1-4.8V71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M372,75.4h-8v10.4h-5.2V60.3H373v4.3h-9v6.6h8V75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M396.6,76.9v9h-5.2V60.3h8.7c2.5,0,4.5,0.8,6.1,2.4s2.3,3.6,2.3,6.1s-0.7,4.5-2.2,5.9s-3.6,2.2-6.2,2.2 H396.6z M396.6,72.6h3.6c1,0,1.7-0.3,2.3-1s0.8-1.6,0.8-2.8c0-1.3-0.3-2.3-0.8-3s-1.3-1.1-2.2-1.2h-3.6V72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M432.2,60.3V78c0,2.7-0.8,4.7-2.2,6.1s-3.5,2.1-6.2,2.1c-2.7,0-4.8-0.7-6.3-2.1c-1.4-1.4-2.2-3.5-2.2-6.2 V60.3h5.2v17.6c0,1.5,0.2,2.5,0.7,3.1c0.5,0.6,1.3,0.9,2.5,0.9s2.1-0.3,2.5-0.9s0.7-1.6,0.7-3V60.3H432.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M439.7,85.9V60.3h7.9c2.7,0,4.7,0.6,6.1,1.8s2.1,2.9,2.1,5.2c0,1.3-0.3,2.4-0.9,3.4s-1.4,1.6-2.4,2.1 c1.1,0.3,2,1,2.7,2s0.9,2.2,0.9,3.7c0,2.5-0.7,4.4-2,5.6s-3.3,1.9-5.9,1.9H439.7z M444.9,71h2.7c2,0,3-1,3-3.1 c0-1.2-0.2-2-0.7-2.5s-1.2-0.8-2.3-0.8h-2.7V71z M444.9,74.7v6.8h3.3c0.9,0,1.6-0.3,2.1-0.9s0.7-1.4,0.7-2.4 c0-2.3-0.8-3.5-2.5-3.5H444.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M468.7,81.6h9.1v4.3h-14.2V60.3h5.2V81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M489.7,85.9h-5.2V60.3h5.2V85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M515,77.4c-0.1,2.9-0.9,5.1-2.5,6.6s-3.6,2.3-6.4,2.3c-2.9,0-5.1-1-6.7-2.9s-2.3-4.6-2.3-8.1v-4.3 c0-3.5,0.8-6.2,2.4-8.1s3.8-2.9,6.6-2.9c2.8,0,4.9,0.8,6.4,2.3s2.3,3.8,2.5,6.7h-5.2c0-1.8-0.3-3-0.8-3.7s-1.4-1-2.8-1 c-1.4,0-2.4,0.5-2.9,1.5s-0.9,2.6-0.9,4.8v4.8c0,2.5,0.3,4.3,0.9,5.2s1.5,1.4,2.9,1.4c1.4,0,2.3-0.3,2.8-1s0.8-1.9,0.9-3.6H515z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M551,77.4c-0.1,2.9-0.9,5.1-2.5,6.6s-3.6,2.3-6.4,2.3c-2.9,0-5.1-1-6.7-2.9s-2.3-4.6-2.3-8.1v-4.3 c0-3.5,0.8-6.2,2.4-8.1s3.8-2.9,6.6-2.9c2.8,0,4.9,0.8,6.4,2.3s2.3,3.8,2.5,6.7h-5.2c0-1.8-0.3-3-0.8-3.7s-1.4-1-2.8-1 c-1.4,0-2.4,0.5-2.9,1.5s-0.9,2.6-0.9,4.8v4.8c0,2.5,0.3,4.3,0.9,5.2s1.5,1.4,2.9,1.4c1.4,0,2.3-0.3,2.8-1s0.8-1.9,0.9-3.6H551z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M575.8,75.4c0,3.4-0.8,6.1-2.4,8s-3.9,2.8-6.8,2.8c-2.9,0-5.1-0.9-6.8-2.8s-2.5-4.5-2.5-7.9v-4.4 c0-3.5,0.8-6.3,2.4-8.2s3.9-3,6.8-3c2.8,0,5.1,1,6.7,2.9s2.5,4.7,2.5,8.2V75.4z M570.7,71.1c0-2.3-0.3-4-1-5.2s-1.7-1.7-3.1-1.7 c-1.4,0-2.4,0.5-3,1.6s-1,2.7-1,4.9v4.6c0,2.2,0.3,3.9,1,4.9s1.7,1.6,3.1,1.6c1.3,0,2.3-0.5,3-1.6s1-2.6,1-4.8V71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M589.9,60.3l4.8,18.5l4.8-18.5h6.8v25.6h-5.2v-6.9l0.5-10.7l-5.1,17.6H593l-5.1-17.6l0.5,10.7v6.9h-5.2V60.3 H589.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M620.8,60.3l4.8,18.5l4.8-18.5h6.8v25.6H632v-6.9l0.5-10.7l-5.1,17.6h-3.5l-5.1-17.6l0.5,10.7v6.9H614V60.3 H620.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M661.6,60.3V78c0,2.7-0.8,4.7-2.2,6.1s-3.5,2.1-6.2,2.1c-2.7,0-4.8-0.7-6.3-2.1s-2.2-3.5-2.2-6.2V60.3h5.2 v17.6c0,1.5,0.2,2.5,0.7,3.1s1.3,0.9,2.5,0.9s2.1-0.3,2.5-0.9s0.7-1.6,0.7-3V60.3H661.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M687,85.9h-5.2l-7.6-16.8v16.8h-5.2V60.3h5.2l7.6,16.8V60.3h5.2V85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M700.2,85.9H695V60.3h5.2V85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M725.4,77.4c-0.1,2.9-0.9,5.1-2.5,6.6s-3.6,2.3-6.4,2.3c-2.9,0-5.1-1-6.7-2.9c-1.5-1.9-2.3-4.6-2.3-8.1v-4.3 c0-3.5,0.8-6.2,2.4-8.1c1.6-1.9,3.8-2.9,6.6-2.9c2.8,0,4.9,0.8,6.4,2.3c1.4,1.6,2.3,3.8,2.5,6.7h-5.2c0-1.8-0.3-3-0.8-3.7 s-1.4-1-2.8-1c-1.4,0-2.4,0.5-2.9,1.5c-0.6,1-0.9,2.6-0.9,4.8v4.8c0,2.5,0.3,4.3,0.9,5.2c0.6,0.9,1.5,1.4,2.9,1.4 c1.4,0,2.3-0.3,2.8-1c0.5-0.7,0.8-1.9,0.9-3.6H725.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M744.4,80.6h-7l-1.4,5.2h-5.5l8-25.6h4.7l8.1,25.6h-5.5L744.4,80.6z M738.5,76.3h4.8l-2.4-9.1L738.5,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M771.8,64.6h-6.3v21.3h-5.2V64.6h-6.2v-4.3h17.7V64.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M783.8,85.9h-5.2V60.3h5.2V85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M809.7,75.4c0,3.4-0.8,6.1-2.4,8s-3.9,2.8-6.8,2.8c-2.9,0-5.1-0.9-6.8-2.8s-2.5-4.5-2.5-7.9v-4.4 c0-3.5,0.8-6.3,2.4-8.2s3.9-3,6.8-3c2.8,0,5.1,1,6.7,2.9s2.5,4.7,2.5,8.2V75.4z M804.5,71.1c0-2.3-0.3-4-1-5.2s-1.7-1.7-3.1-1.7 c-1.4,0-2.4,0.5-3,1.6s-1,2.7-1,4.9v4.6c0,2.2,0.3,3.9,1,4.9s1.7,1.6,3.1,1.6c1.3,0,2.3-0.5,3-1.6s1-2.6,1-4.8V71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M834.9,85.9h-5.2l-7.6-16.8v16.8H817V60.3h5.2l7.6,16.8V60.3h5.2V85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M853.5,79.2c0-1-0.3-1.8-0.8-2.4s-1.5-1.1-2.9-1.7c-2.6-1-4.4-2.1-5.5-3.4s-1.7-2.9-1.7-4.6 c0-2.2,0.8-3.9,2.3-5.2s3.5-2,5.8-2c1.6,0,3,0.3,4.2,1s2.2,1.6,2.8,2.8s1,2.6,1,4.1h-5.2c0-1.2-0.3-2.1-0.8-2.7s-1.2-0.9-2.2-0.9 c-0.9,0-1.6,0.3-2.1,0.8s-0.8,1.3-0.8,2.2c0,0.7,0.3,1.3,0.8,1.9s1.6,1.2,3,1.8c2.5,0.9,4.3,2,5.4,3.3s1.7,3,1.7,5 c0,2.2-0.7,4-2.1,5.2s-3.3,1.9-5.8,1.9c-1.7,0-3.2-0.3-4.5-1s-2.4-1.7-3.2-2.9s-1.2-2.8-1.2-4.5h5.2c0,1.5,0.3,2.5,0.9,3.2 s1.5,1,2.8,1C852.6,82,853.5,81.1,853.5,79.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 112,
    className: "st1",
    width: 684,
    height: 8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1_copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 27,
    className: "st1",
    width: 684,
    height: 8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectPr);
export default __webpack_public_path__ + "static/media/perfect_pr.f8531135def85788a980f232c5ab8d56.svg";
export { ForwardRef as ReactComponent };